import { render, staticRenderFns } from "./mark-on-file-modal.vue?vue&type=template&id=7dac30d2&scoped=true&"
import script from "./mark-on-file-modal.vue?vue&type=script&lang=ts&"
export * from "./mark-on-file-modal.vue?vue&type=script&lang=ts&"
import style0 from "./mark-on-file-modal.vue?vue&type=style&index=0&id=7dac30d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac30d2",
  null
  
)

export default component.exports